'use client';

import { Typography } from '@bgzt/ui';

import { Coupon } from '~/apis/coupon';
import IcEnableCouponDownload from '~/public/assets/icons/ic_enable_coupon_download.svg';
import IcDisableCouponDownload from '~/public/assets/icons/ic_disable_coupon_download.svg';
import { Spacing } from '~/components/Spacing';

import styles from './IssuableCoupon.module.css';

type Props = {
  coupon: Coupon;
};

export const IssuableCoupon = ({ coupon }: Props) => {
  const renderCouponDownloadText = (count: number) => {
    return count === 1 ? '받기' : `${count}장 받기`;
  };
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="S1" color="gray-900">
          {coupon.viewTitle}
        </Typography>
        <Spacing height={6} />

        <Typography variant="L7" color="gray-900">
          {coupon.viewSubTitle}
        </Typography>
        <Spacing height={4} />

        <Typography variant="C2" color="gray-500" className={styles.couponCondition}>
          {coupon.viewPreCondition}
          <br />
          {coupon.viewTimeLeft}
        </Typography>
      </div>
      <div className={styles.perforation}>
        {coupon.downloadable ? <IcEnableCouponDownload /> : <IcDisableCouponDownload />}
        <Typography variant="L13" color={coupon.downloadable ? 'red-500' : 'gray-150'}>
          {coupon.downloadable ? renderCouponDownloadText(coupon.maxIssueCountPerUser) : '받기 완료'}
        </Typography>
      </div>
    </div>
  );
};
